import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { LANDING_PAGE_ROUTE, PRODUCTS_ROUTE } from '@mwe/constants';
import { AccountLogic } from '@mwe/services';
import { EnvironmentCustomerType } from '@mwe/environment';
import { RouterLink } from '@angular/router';
import { HeaderLogoImageComponent } from './header-logo-image.component';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'mwe-header-logo',
  standalone: true,
  templateUrl: './header-logo.component.html',
  imports: [RouterLink, HeaderLogoImageComponent, TranslateDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderLogoComponent {
  private accountLogic = inject(AccountLogic);

  title = input<string>('global.title');
  customerType = input<EnvironmentCustomerType>();

  targetRoute = computed(() => (this.accountLogic.isLoggedIn() ? `/${PRODUCTS_ROUTE}` : `/${LANDING_PAGE_ROUTE}`));
}
